import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type AccordionItemProps = {
  title: string;
  children: React.ReactNode;
  index: number;
  previewImage?: string;
};
export function AccordionItem({
  title,
  children,
  index,
  previewImage
}: AccordionItemProps) {
  const [open, setOpen] = useState(index === 0);
  return <article className="overflow-hidden rounded-xl border border-sky-200 bg-white/90 shadow-sm" data-id="element-1">
      <button type="button" className="flex w-full items-center gap-3 px-3 py-3 text-left focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-inset" onClick={() => setOpen(value => !value)} aria-expanded={open} data-id="element-2">
        {previewImage && <div className="bonus-inline-preview shrink-0 overflow-hidden rounded-lg" data-id="element-3">
            <img src={previewImage} alt="" className="h-14 w-20 object-cover object-top" data-id="element-4" />
          </div>}
        <span className="min-w-0 flex-1 text-sm font-extrabold leading-snug text-slate-800" data-id="element-5">
          {title}
        </span>
        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sky-600 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-6" />
      </button>
      {open && <div className="border-t border-sky-100 px-4 py-4 text-sm leading-relaxed text-slate-600" data-id="element-7">
          {children}
        </div>}
    </article>;
}